import { Box } from '@mui/material';
import { P1M, P1R, Icon } from 'src/components';
import { themeColors } from 'src/theme';
import { ReactComponent as FileXlsxIcon } from 'src/assets/fileXlsx.svg';

type Props = {
  fileName: string;
  errorCount: number;
  totalUsers: number;
  onRemove: () => void;
};

const UploadedFileInfo = ({ fileName, errorCount, totalUsers, onRemove }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        p: 2,
        border: `1px solid ${themeColors.grayMedium}`,
        borderRadius: 2,
        mb: 4,
        background: themeColors.grayLight,
        color: themeColors.black,
      }}
    >
      <Box
        sx={{
          background: themeColors.white,
          borderRadius: 2,
          p: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mr: 2,
          border: `1px solid ${themeColors.grayMedium}`,
        }}
      >
        <FileXlsxIcon />
      </Box>
      <Box sx={{ flexGrow: 1 }}>
        <P1R component="span">{fileName}</P1R>
      </Box>
      {errorCount ? <Icon name="exclamationRed" sx={{ mr: 1 }} /> : <Icon name="accepted" sx={{ mr: 1 }} />}
      <P1R component="span" sx={{ mr: 2 }}>
        {' '}
        <P1M>{`${errorCount}/${totalUsers}`}</P1M> Users have errors
      </P1R>
      <Box sx={{ cursor: 'pointer', color: themeColors.red }} onClick={onRemove}>
        <Icon name="delete" />
      </Box>
    </Box>
  );
};

export default UploadedFileInfo;
